import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyFolder = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 412,
	height: 140,
	viewBox: "0 0 412 140",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("line", {
			x1: 82.0621,
			y1: 57.4402,
			x2: 17.0621,
			y2: 72.4402,
			stroke: "#D9DEEB",
			strokeWidth: .5607
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 95.1314,
			y1: 60.9196,
			x2: 149.083,
			y2: 89.5506,
			stroke: "#D9DEEB",
			strokeWidth: .5607
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.99999 82.1677C13.4183 82.1677 17 78.586 17 74.1677C17 69.7494 13.4183 66.1677 8.99999 66.1677C4.58171 66.1677 1 69.7494 1 74.1677C1 78.586 4.58171 82.1677 8.99999 82.1677Z",
			stroke: "#D9DEEB",
			strokeWidth: .56693,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .9,
			d: "M9.00048 77.167C10.6573 77.167 12.0005 75.8238 12.0005 74.167C12.0005 72.5101 10.6573 71.167 9.00048 71.167C7.34362 71.167 6.00049 72.5101 6.00049 74.167C6.00049 75.8238 7.34362 77.167 9.00048 77.167Z",
			fill: "#8CBCEF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M89.999 63.1682C94.4173 63.1682 97.999 59.5865 97.999 55.1682C97.999 50.7499 94.4173 47.1682 89.999 47.1682C85.5807 47.1682 81.999 50.7499 81.999 55.1682C81.999 59.5865 85.5807 63.1682 89.999 63.1682Z",
			stroke: "#D9DEEB",
			strokeWidth: .56693,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .9,
			d: "M89.9995 58.1687C91.6564 58.1687 92.9995 56.8256 92.9995 55.1687C92.9995 53.5119 91.6564 52.1687 89.9995 52.1687C88.3427 52.1687 86.9995 53.5119 86.9995 55.1687C86.9995 56.8256 88.3427 58.1687 89.9995 58.1687Z",
			fill: "#8CBCEF"
		}),
		/* @__PURE__ */ _jsx("line", {
			y1: -.28035,
			x2: 74.3229,
			y2: -.28035,
			transform: "matrix(-0.920735 -0.39019 -0.390189 0.920735 284.433 117.407)",
			stroke: "#D9DEEB",
			strokeWidth: .5607
		}),
		/* @__PURE__ */ _jsx("line", {
			y1: -.28035,
			x2: 55.4436,
			y2: -.28035,
			transform: "matrix(0.991998 0.126254 0.126254 -0.991998 340.002 51.4072)",
			stroke: "#D9DEEB",
			strokeWidth: .5607
		}),
		/* @__PURE__ */ _jsx("line", {
			y1: -.28035,
			x2: 64.0078,
			y2: -.28035,
			transform: "matrix(0.484316 -0.874893 -0.874893 -0.484316 297.002 114.407)",
			stroke: "#D9DEEB",
			strokeWidth: .5607
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M332.001 43.408C336.419 43.408 340.001 46.9897 340.001 51.408C340.001 55.8262 336.419 59.408 332.001 59.408C327.583 59.408 324.001 55.8262 324.001 51.408C324.001 46.9897 327.583 43.408 332.001 43.408Z",
			stroke: "#D9DEEB",
			strokeWidth: .5607,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M332.002 48.4072C333.659 48.4072 335.002 49.7504 335.002 51.4072C335.002 53.0641 333.659 54.4072 332.002 54.4072C330.345 54.4072 329.002 53.0641 329.002 51.4072C329.002 49.7504 330.345 48.4072 332.002 48.4072Z",
			fill: "#8CBCEF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M403.001 51.407C407.42 51.407 411.001 54.9887 411.001 59.407C411.001 63.8253 407.42 67.407 403.001 67.407C398.583 67.407 395.001 63.8253 395.001 59.407C395.001 54.9887 398.583 51.407 403.001 51.407Z",
			stroke: "#D9DEEB",
			strokeWidth: .5607,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M403.002 56.4062C404.659 56.4062 406.002 57.7494 406.002 59.4062C406.002 61.0631 404.659 62.4063 403.002 62.4063C401.345 62.4063 400.002 61.0631 400.002 59.4062C400.002 57.7494 401.345 56.4062 403.002 56.4062Z",
			fill: "#8CBCEF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M292.001 112.407C296.42 112.407 300.001 115.989 300.001 120.407C300.001 124.826 296.42 128.407 292.001 128.407C287.583 128.407 284.001 124.826 284.001 120.407C284.001 115.989 287.583 112.407 292.001 112.407Z",
			stroke: "#D9DEEB",
			strokeWidth: .5607,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .9,
			d: "M292.002 117.407C293.659 117.407 295.002 118.75 295.002 120.407C295.002 122.064 293.659 123.407 292.002 123.407C290.345 123.407 289.002 122.064 289.002 120.407C289.002 118.75 290.345 117.407 292.002 117.407Z",
			fill: "#8CBCEF"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M72.2448 103.479C72.2448 105.499 70.6147 107.129 68.5947 107.129C66.5747 107.129 64.9448 105.499 64.9448 103.479C64.9448 101.459 66.5747 99.8289 68.5947 99.8289C70.6147 99.8289 72.2448 101.459 72.2448 103.479Z",
			fill: "#006ADC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M393.046 118.411C388.805 124.867 382.277 133.316 373.371 130.206C364.623 127.145 367.859 116.535 370.96 110.505C373.246 106.04 376.063 101.832 379.363 98.0503C381.503 95.592 385.069 92.2302 388.666 93.7023C391.748 94.9711 392.127 98.8176 391.119 101.596C389.648 105.611 386.429 109.963 383.294 112.806C380.452 115.388 376.353 117.124 372.494 115.968C368.977 114.9 366.849 111.555 366.213 108.076C365.423 103.75 366.538 98.1995 368.406 94.2431C369.549 91.8396 372.177 89.8468 374.648 91.8996C377.584 94.3256 376.2 98.2652 374.37 100.858C371.886 104.355 368.714 108.473 364.418 109.749C361.155 110.722 357.395 109.923 355.598 106.83C353.831 103.791 354.411 99.8844 355.147 96.6347C355.761 93.9499 356.991 89.5946 360.478 89.6688C364.003 89.7485 364.947 94.2364 363.516 96.7872C361.308 100.731 355.758 102.594 351.576 103.266C346.628 104.065 341.584 103.291 337.076 101.126C336.509 100.851 336.897 99.9457 337.477 100.222C343.334 103.031 350.191 103.377 356.255 100.957C359.164 99.8043 363.848 97.3689 363.2 93.5334C362.857 91.4923 360.756 89.7608 358.752 91.2251C357.343 92.2582 356.742 94.2603 356.325 95.8716C355.725 98.2036 355.234 100.742 355.498 103.151C355.93 107.323 359.268 109.859 363.457 108.96C366.875 108.225 369.353 105.538 371.475 102.938C373.489 100.474 377.676 95.5815 374.016 92.6551C369.926 89.3858 368.195 97.799 367.675 100.105C366.906 103.489 366.493 107.129 367.932 110.41C369.457 113.882 372.695 115.808 376.476 115.19C380.281 114.576 383.149 111.909 385.413 108.95C387.176 106.638 389.237 103.94 390.205 101.181C390.886 99.2415 390.951 96.6654 389.231 95.1931C387.173 93.4298 384.44 94.7606 382.645 96.1799C377.619 100.149 373.845 106.7 371.125 112.38C368.295 118.298 366.373 128.419 375.514 129.688C383.426 130.787 388.493 123.553 392.278 117.777C392.623 117.246 393.406 117.869 393.048 118.399L393.046 118.411Z",
			fill: "#8C94AA"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M167.788 34.2112L167.842 33.0489C168.012 29.3845 170.815 26.3848 174.46 25.9679L196.992 23.3901C196.509 19.3069 199.474 15.4873 203.713 15.0852L240.341 11.6109C243.979 11.266 247.332 13.6003 248.272 17.131L248.373 17.5116L269.462 15.0989C274.052 14.5737 278.015 18.2967 277.778 22.9109L273.823 99.7105C273.725 101.614 272.917 103.335 271.651 104.604C271.26 105.308 270.791 105.934 270.223 106.484C269.434 107.248 268.748 107.887 267.838 108.431C266.718 109.386 265.3 110.025 263.7 110.176L257.748 110.741C257.603 110.755 257.457 110.769 257.308 110.784C257.292 110.785 257.277 110.786 257.261 110.787L167.147 119.335C163.55 119.676 160.224 117.396 159.245 113.918L140.036 45.6967C138.771 41.2069 141.882 36.6684 146.526 36.2279L167.788 34.2112Z",
			fill: "#D9DEEB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M277.327 24.1798C278.088 19.6224 274.573 15.4731 269.953 15.4731H174.331C170.663 15.4731 167.536 18.1347 166.951 21.756L154.688 97.6084C153.953 102.154 157.463 106.278 162.068 106.278H257.294C260.948 106.278 264.067 103.636 264.668 100.032L277.327 24.1798Z",
			fill: "#00458F"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M196.141 18.1221C195.334 13.5443 198.855 9.34692 203.504 9.34692H240.296C243.95 9.34692 247.068 11.9876 247.67 15.5912L250.767 34.1335L260.715 90.5986C261.514 92.6867 262.451 93.5243 263.96 93.5243C264.98 93.5243 266.001 91.9939 266.511 88.933L266.461 89.2327C265.338 95.9764 264.55 100.704 261.41 103.217C260.547 103.907 259.801 104.48 258.837 104.937C257.635 105.776 256.168 106.273 254.568 106.273H249.215C248.871 106.276 248.515 106.278 248.146 106.278C248.107 106.278 248.069 106.276 248.035 106.273H157.582C153.969 106.273 150.873 103.689 150.226 100.134L137.545 30.4037C136.711 25.8145 140.236 21.59 144.901 21.59H196.753L196.141 18.1221Z",
			fill: "#1A79E0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M179.921 72.5296L176.217 72.7945L175.994 72.8128C175.309 72.8496 175.08 73.1317 174.899 73.4728L172.31 78.1531L169.209 73.9701L169.106 73.8331C169.106 73.8331 169.021 73.7103 168.887 73.7151L168.886 73.7152C168.753 73.7295 168.686 73.8631 168.686 73.8631L168.604 74.0134L166.225 78.5883L162.901 74.3308C162.672 74.0191 162.406 73.7724 161.723 73.8335L161.5 73.847L157.795 74.112L158.058 77.7636L160.239 77.6076C160.699 77.5702 160.913 77.5773 161.256 77.9473L161.401 78.1365L166.32 84.9719C166.32 84.9719 166.48 85.1926 166.723 85.1767C166.985 85.1588 167.114 84.9146 167.114 84.9146L169.394 80.7414L169.394 80.7413L172.348 84.5348C172.348 84.5348 172.515 84.7603 172.742 84.7501C172.986 84.7389 173.102 84.4863 173.102 84.4863L176.93 77.0259L177.046 76.8181C177.245 76.4361 177.527 76.3774 177.985 76.3491L180.169 76.1915L179.921 72.5296Z",
			fill: "#005ABB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M175.068 83.0795L172.975 87.1537L169.586 82.7724L167.496 86.6119L173.042 94.3304C173.229 94.5413 173.369 94.5785 173.438 94.5759C173.589 94.572 173.67 94.4824 173.811 94.1883L177.177 86.5376C177.477 85.8724 178.057 85.8393 178.057 85.8393L180.867 85.6384L180.604 81.9916L176.217 82.3053C175.418 82.3625 175.068 83.0795 175.068 83.0795Z",
			fill: "#005ABB"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 45.1529,
			cy: 28.6304,
			rx: 13.1651,
			ry: 13.1651,
			transform: "rotate(-10.3463 45.1529 28.6304)",
			fill: "#002E5F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M40.2058 29.5277L44.6944 32.3098L49.3135 25.1637",
			stroke: "white",
			strokeWidth: .5607,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M162.743 112.367C148.085 112.304 142.579 103.451 141.428 92.3059",
			stroke: "#002E5F",
			strokeWidth: .475815,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 283.296,
			y1: 32.4025,
			x2: 278.375,
			y2: 57.0124,
			stroke: "#002E5F",
			strokeWidth: .475815,
			strokeLinecap: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgEmptyFolder);
export default ForwardRef;
